var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('Header',{staticClass:"header",attrs:{"val":_vm.headerTitle}}),_c('div',{staticClass:"container"},[_c('div',{attrs:{"id":"content"}},[void 0],2),_c('QuickMenu')],1),_c('footer',{staticClass:"footer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }